import React from 'react'
import { useTranslation } from 'react-i18next'

import { useScrollToTop } from '@hooks/useScrollToTop'

import {
  StatusTemplateBody,
  StatusTemplateWrapper,
} from '@shared/templates/StatusTemplate/StatusTemplate'

export const SumsubThankYouPage: React.FC = () => {
  useScrollToTop()
  const { t } = useTranslation()

  return (
    <StatusTemplateWrapper>
      <StatusTemplateBody
        title={t('Thank you for registering with Tickmill')}
        text={[t('The verification process is in progress')]}
        icon={'Info'}
      />
    </StatusTemplateWrapper>
  )
}
